export const fileViewer = function (url) {
    const fileTypeList = ['.pdf', '.doc', '.docx', '.xls', '.xlsx']
    const fileType = fileTypeList.find(item => url.indexOf(item) !== -1)
    console.log(fileType)
    if (fileType == '.pdf') {//pdf文件
        let fileUrl = encodeURIComponent(url)
        window.open("https://m.nutriease.com/pdfjs/web/viewer.html?file=" + fileUrl);
    } else if (!fileType) {//其他文件
        window.open(url);
    } else {//office文件
        const fileUrl = "https://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(url);
        window.open(fileUrl);
    }
}

import { Toast } from 'vant';

export function dateFormat(fmt, date) {
    let ret;
    const opt = {
        "Y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString(), // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
            fmt = fmt.replace(
                ret[1],
                ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
            );
        }
    }
    return fmt;
}

// 深拷贝
export function deepClone(target) {
    // 定义一个变量
    let result;
    // 如果当前需要深拷贝的是一个对象的话
    if (typeof target === 'object') {
        // 如果是一个数组的话
        if (Array.isArray(target)) {
            result = []; // 将result赋值为一个数组，并且执行遍历
            for (let i in target) {
                // 递归克隆数组中的每一项
                result.push(deepClone(target[i]))
            }
            // 判断如果当前的值是null的话；直接赋值为null
        } else if (target === null) {
            result = null;
            // 判断如果当前的值是一个RegExp对象的话，直接赋值    
        } else if (target.constructor === RegExp) {
            result = target;
        } else {
            // 否则是普通对象，直接for in循环，递归赋值对象的所有值
            result = {};
            for (let i in target) {
                result[i] = deepClone(target[i]);
            }
        }
        // 如果不是对象的话，就是基本数据类型，那么直接赋值
    } else {
        result = target;
    }
    // 返回最终结果
    return result;
}

/**
 * 将地址栏参数变成对象返回
 * @returns {name:"xxx"}
 */
export function getUrlParams(urlStr) {
    let url = window.location.href.split('?')[1]
    if (urlStr) {
        url = urlStr.split('?')[1]
    }
    let urlObj = {}
    if (url !== undefined) {
        if (url.indexOf("&") > -1) {
            url = url.split("&")
        } else {
            url = [url]
        }
        for (let item of url) {
            let arr = item.split('=')
            urlObj[arr[0]] = arr[1]
        }
    }
    return urlObj
}

/** 
   * 调用客户端原生方法
   * obj={
   *  android(){},
   *  ios(){},
   * }
  */
export function appNative(obj) {
    const u = navigator.userAgent;
    const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
        try {
            obj.android()
        } catch {
            // alert("请在客户端操作");
        }
    } else if (isiOS) {
        try {
            obj.ios()
        } catch {
            // alert("请在客户端操作");
        }
    } else {
        // 其他终端
        obj.other && obj.other()
    }
}

// 设置页面标题
export function setWebTitle(title) {
    setTimeout(function () {
        window.document.title = title
        appNative({
            android() {
                window.android.setWebviewTitle(title);
            },
            ios() {
                window.webkit.messageHandlers.setWebviewTitle.postMessage(title);
            },
            other() {
                window.document.title = title
            }
        });
    }, 30)

}

// setToken
export function setToken(token) {
    let p = new Promise((resolve, reject) => {
        if (token) {
            localStorage.setItem("token", token);
            resolve(token)
        } else {
            localStorage.removeItem("token");
        }
    })
    return p

}

/**
 * 
 * @param {*} n 
 * @returns 
 */
const formatNumber = n => {
    n = n.toString()
    return n[1] ? n : '0' + n
}
// 获取今天日期
export function formatYYYYMMDD(date) {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()

    return [year, month, day].map(formatNumber).join('-')
}

export function formatHHMMSS(date) {
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()
    return [hour, minute, second].map(formatNumber).join(':')
}

// date 代表指定的日期，格式：2018-09-27
// day 传-1表始前一天，传1表始后一天
// JS获取指定日期的前一天，后一天
export function getNextDate(date, day) {
    var dd = new Date(date);
    dd.setDate(dd.getDate() + day);
    var y = dd.getFullYear();
    var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
    var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
    return y + "-" + m + "-" + d;
};

// 如果time2大于time1 返回true 否则 返回false
export function compareTime(time1, time2) {
    if (time_to_sec(time2) - time_to_sec(time1) > 0) {
        return true;
    }
    return false;
}

//将时分秒转为时间戳
function time_to_sec(time) {
    if (time !== null) {
        var s = "";
        var hour = time.split(":")[0];
        var min = time.split(":")[1];
        var sec = time.split(":")[2];
        s = Number(hour * 3600) + Number(min * 60) + Number(sec);
        return s;
    }
}

//节流函数，一段时间内频繁触发只执行1次该方法
export function throttle(func, delay) {
    var timer = null
    return function () {
        var context = this
        var args = arguments
        if (!timer) {
            timer = setTimeout(function () {
                func.apply(context, args)
                timer = null
            }, delay)
        }
    }
}

export function formatTime2(date) {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()

    const today = new Date()
    const todayYear = today.getFullYear()
    const todayMonth = today.getMonth() + 1
    const todayDay = today.getDate()

    // 今天的日期只展示时分
    if (year == todayYear && month == todayMonth && day == todayDay) {
        return [hour, minute].map(formatNumber).join(':')
    } else {
        return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute].map(formatNumber).join(':')
    }

}

//数组对象去重，保留最后一个
export function arrayUnique(arr, name) {
    let hash = {}
    return arr.reduce((acc, cru, index) => {
        if (!hash[cru[name]]) {
            hash[cru[name]] = { index: acc.length }
            acc.push(cru)
        } else {
            acc.splice(hash[cru[name]]['index'], 1, cru)
        }
        return acc;
    }, [])
}

/**
 * 只能输入整数和小数，并指定小数点后的位数
 * @param {*} value 待校验的值
 * @param {*} decimalNum 小数点后位数
 * @param {*} maxNum 最大值
 * @param {*} errMsg 错误提示
 * @returns 返回格式化后的数字
 */
export function setDecimal(value, decimalNum, maxNum, errMsg) {
    value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
    value = value.replace(/^\./g, ""); //验证第一个字符是数字
    value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
    value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
    if (decimalNum == 1) {
        value = value.replace(/^(\-)*(\d+)\.(\d).*$/, "$1$2.$3"); //只能输入一个小数
    }
    if (decimalNum == 2 || !decimalNum) {
        value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
    }
    if (value.indexOf(".") < 0 && value != "") {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02
        value = parseFloat(value);
    }
    if (maxNum && parseFloat(value) > maxNum) {
        value = maxNum;
        Toast(errMsg);
    }
    return value;
}

// 判断当前环境是否是在小程序
export function ifWechatMini() {
    let ua = navigator.userAgent;
    let p = new Promise((resolve, reject) => {
        if (/micromessenger/i.test(ua)) {
            wx.miniProgram.getEnv((res) => {
                if (res.miniprogram) {
                    console.log("小程序环境", res);
                    resolve(true)
                } else {
                    console.log("微信环境", res);
                    resolve(false)
                }
            })
        } else {
            resolve(false)
        }
    })
    return p
}

// H5向小程序webview传值
export function postMsgToMiniApp(data) {
    data = Object.assign({
        title: 'xxx',
        desc: '',
        path: '/index',
        imageUrl: '',
    }, data)
    console.log("分享data：", data)
    ifWechatMini().then((f) => {
        if (f) {
            wx.miniProgram.postMessage({
                data
            })
        }
    })
}

export function formatTimestamp(stamp) {
    let date = new Date(stamp * 1000);  // 参数需要毫秒数，所以这里将秒数乘于 1000
    let Y = date.getFullYear() + '-';
    let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    let D = date.getDate() + ' ';
    let h = date.getHours() + ':';
    let m = date.getMinutes() + ':';
    let s = date.getSeconds();
    return (Y + M + D + h + m + s);
}

/**
 * 返回到页面顶部
 */
export function scrollToTop() {
    const container = document.querySelector("#app");
    if (container) {
        container.scrollTo(0, 0);
    }
}

/**
 * 年龄计算
 */
export function getAge(val) {
    let currentYear = new Date().getFullYear() //当前的年份
    let calculationYear = new Date(val).getFullYear() //计算的年份
    const wholeTime = currentYear + val.substring(4) //周岁时间
    const calculationAge = currentYear - calculationYear //按照年份计算的年龄
    //判断是否过了生日
    if (new Date().getTime() > new Date(wholeTime).getTime()) {
        return calculationAge
    } else {
        return calculationAge - 1
    }
}